import React from 'react';

export default function DistributionBar({ title, data, total, onBarClick, activeValue }) {
  if (!data || data.length === 0) return null;

  return (
    <div className="space-y-2">
      <h4 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">{title}</h4>
      <div className="space-y-1.5">
        {data.map(({ label, count }) => {
          const pct = total > 0 ? (count / total) * 100 : 0;
          const isActive = activeValue === label;
          return (
            <button
              key={label}
              onClick={() => onBarClick(label)}
              className={`w-full flex items-center gap-2 group text-left rounded px-1.5 py-0.5 transition-colors ${isActive ? 'bg-primary/10' : 'hover:bg-muted'}`}
            >
              <span className="text-xs font-medium text-foreground w-28 truncate">{label}</span>
              <div className="flex-1 h-3.5 bg-muted rounded-full overflow-hidden">
                <div
                  className={`h-full rounded-full transition-all ${isActive ? 'bg-primary' : 'bg-navy/60 group-hover:bg-navy/80'}`}
                  style={{ width: `${Math.max(pct, 2)}%` }}
                />
              </div>
              <span className="text-xs text-muted-foreground w-10 text-right tabular-nums">{count}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}